export const FormatsData: {[k: string]: ModdedSpeciesFormatsData} = {
	aegislash: {
		inherit: true,
		tier: "OU",
	},
	blaziken: {
		inherit: true,
		tier: "OU",
	},
	blazikenmega: {
		inherit: true,
		tier: "OU",
	},
	genesect: {
		inherit: true,
		tier: "OU",
	},
	gengarmega: {
		inherit: true,
		tier: "OU",
	},
	greninja: {
		inherit: true,
		tier: "OU",
	},
	kangaskhanmega: {
		inherit: true,
		tier: "OU",
	},
	landorus: {
		inherit: true,
		tier: "OU",
	},
	mawilemega: {
		inherit: true,
		tier: "OU",
	},
	salamencemega: {
		inherit: true,
		tier: "OU",
	},
	deoxysdefense: {
		inherit: true,
		tier: "Uber",
	},
	deoxysspeed: {
		inherit: true,
		tier: "Uber",
	},
	hoopaunbound: {
		inherit: true,
		tier: "OU",
	},
	kyurem: {
		inherit: true,
		tier: "Uber",
	},
	kyuremblack: {
		inherit: true,
		tier: "Uber",
	},
};
